import * as React from "react";
import { reducer, initState } from "../../../../reducers/report/outline";
import { Loading } from "../../../../../../react-components/lu-component/src/index";
import { ConfirmBox } from "../../../../components/parts/confirm-box";
import { get, makeError } from "../../../../lib/request";
import { GetOutlineResponse } from "../../../../../../server/types/request/report/outline";
import { replaceEndpointUrl, v3ApiEndpoint } from "../../../../../../server/router/endpoint";
import { useParams } from "react-router-dom";
import { clientEndpoint } from "../../../../routes/endpoint";
import { ReportBigTitle } from "../../../../components/pages/report/parts/report-title";
import { ConceptPanel } from "../../../../components/pages/report/outline/concept-panel";

export const ConceptReportContainer = () => {
	const [state, dispatch] = React.useReducer(reducer, initState);
	const { loading, info, activity, data } = state;
	const { jobId, activityId } = useParams<{
		jobId: string;
		activityId: string;
	}>();
	React.useEffect(() => {
		get<GetOutlineResponse>(`${v3ApiEndpoint.outline}/${jobId}`)
			.then((response) => {
				dispatch({ type: "loadData", payload: response.data });
			})
			.catch((error) => {
				dispatch({ type: "changeMessageInfo", payload: makeError(error) });
			});
	}, [jobId]);
	const _onViewQuotaPage = React.useCallback(
		(jobId: string) => {
			window.open(replaceEndpointUrl(clientEndpoint.quota, { jobId, activityId }));
		},
		[activityId],
	);
	return (
		<>
			<Loading loading={loading} />
			<ConfirmBox info={info} />
			{!!activity &&
				data.map((d, index) => {
					return (
						<React.Fragment key={`outline-${index}`}>
							<ReportBigTitle>
								{index === 0 ? "テストのコンセプト" : "前回のコンセプト"}（{d.job.jobNum}）
							</ReportBigTitle>
							<ConceptPanel concepts={d.concepts} />
						</React.Fragment>
					);
				})}
		</>
	);
};
